import {fetchData, PersonInfoRequest, PersonInfoResponse, UploadDocumentRequest} from '@api'
import {APIMethod, Country} from '@enums'

import {CreditCheckRequest, CreditCheckResponse, SigningRequest} from './types'

/**
 * Checks the Credit score for a specific person
 * @param body Credit Check payload data
 * @returns Credit Check result
 */
export const creditCheck = async (body: CreditCheckRequest): Promise<CreditCheckResponse> => {
  const {country, customer, purchasePrice, companyId, personNumber} = body
  let url = ''
  let requestBody

  switch (country) {
    case Country.SWEDEN:
      url = 'credit-safe/sweden/credit-check'
      requestBody = {
        number: personNumber,
        lang: 'EN',
      }
      break
    case Country.NORWAY:
      url = `credit-safe/norway/credit-check`
      requestBody = {
        id: personNumber,
        purchasePrice,
      }
      break
    case Country.DENMARK:
      url = 'experian/denmark'
      requestBody = {
        number: personNumber,
      }
      break
    default:
      url = 'experian/general/credit-check'
      requestBody = {
        customerRefId: '',
        ...customer,
      }
  }

  return fetchData({
    method: APIMethod.POST,
    url,
    body: {...requestBody, companyId},
  })
}

export const uploadDocument = async (body: UploadDocumentRequest): Promise<boolean> => {
  return fetchData({
    method: APIMethod.POST,
    url: 'api/invoices/verify-expense',
    body,
    contentType: 'multipart/form-data',
  })
}

/**
 * @param body Person info payload data
 * @returns Person information
 */
export const getPersonInfo = async (body: PersonInfoRequest): Promise<PersonInfoResponse> => {
  const {country, personNumber} = body
  let url = ''
  let requestBody

  switch (country) {
    case Country.SWEDEN:
      url = 'credit-safe/sweden/person-info'
      requestBody = {
        number: personNumber,
        lang: 'EN',
      }
      break
    case Country.NORWAY:
      url = `credit-safe/norway/person-info`
      requestBody = {
        id: personNumber,
        purchasePrice: 0,
      }
      break
    case Country.DENMARK:
      url = 'experian/denmark/person-info'
      requestBody = {
        number: personNumber,
      }
      break
  }

  return fetchData({
    method: APIMethod.POST,
    url,
    body: requestBody,
  })
}

/**
 * Send a PDF Contract for signing
 * @param body Signing request payload data
 * @returns void
 */
export const sendForSigning = async (body: SigningRequest): Promise<string> => {
  const formData = new FormData()

  const fileBlob = new Blob([body.file], {type: 'application/pdf'})

  formData.append('file', fileBlob, body.documentName)

  formData.append('documentName', `${body.documentName}.pdf`)
  formData.append('contractId', body.contractId)
  formData.append('greeting', body.greeting)

  formData.append('recipientDto', new Blob([JSON.stringify(body.recipientDto)], {type: 'application/json'}))

  return fetchData({
    method: APIMethod.POST,
    url: `verified/process-contract`,
    contentType: 'multipart/form-data',
    body: formData,
  })
}
